import React, { Component } from "react";
import { Box } from "reflexbox";
// import SellerOrdersTableContainer from "./_SellerOrdersTable";
// import SellerOrderForm from "./_SellerOrderForm";

class Seller extends Component {
  render() {
    return (
      <Box flex>
        <Box w={0.75}>
          {/* <SellerOrdersTableContainer /> */}
        </Box>
        <Box auto m={2}>
          {/* <SellerOrderForm /> */}
        </Box>
      </Box>
    );
  }
}

export default Seller;



// WEBPACK FOOTER //
// ./src/views/Seller/index.js